import { useEffect, useRef, useState } from "react";
import { replayCardPngFile } from "../lib/shareCard";

type ShareCardPreparation = {
  name: string;
  landscapeSvg: string;
  portraitSvg: string;
};

export function usePreparedReplayCard({ name, landscapeSvg, portraitSvg }: ShareCardPreparation) {
  const [mobile, setMobile] = useState(() => typeof window !== "undefined" && (window.matchMedia?.("(max-width: 800px)").matches ?? window.innerWidth <= 800));
  const fileRef = useRef<File | null>(null);
  const statusRef = useRef<"preparing" | "ready" | "unavailable">("preparing");

  useEffect(() => {
    const media = window.matchMedia("(max-width: 800px)");
    const update = () => setMobile(media.matches);
    update();
    if (media.addEventListener) media.addEventListener("change", update);
    else media.addListener(update);
    return () => {
      if (media.removeEventListener) media.removeEventListener("change", update);
      else media.removeListener(update);
    };
  }, []);

  useEffect(() => {
    let active = true;
    fileRef.current = null;
    statusRef.current = "preparing";
    const slug = name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "equity-replay";
    void replayCardPngFile(mobile ? portraitSvg : landscapeSvg, `${slug}-replay.png`).then((file) => {
      if (!active) return;
      fileRef.current = file;
      statusRef.current = "ready";
    }).catch(() => {
      if (active) statusRef.current = "unavailable";
    });
    return () => { active = false; };
  }, [landscapeSvg, mobile, name, portraitSvg]);

  return { fileRef, statusRef };
}
